import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const RegistrarModulo = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();

  const moduloFromState = state?.modulo;

  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  const [nombreModulo, setNombreModulo] = useState("");
  const [descripcionModulo, setDescripcionModulo] = useState("");
  const [rutaModulo, setRutaModulo] = useState("");
  const [iconoModulo, setIconoModulo] = useState("");
  const [estadoModulo, setEstadoModulo] = useState(true);

  useEffect(() => {
    setEdit(!!id);
  }, [id]);

  const cleanData = () => {
    setNombreModulo("");
    setDescripcionModulo("");
    setRutaModulo("");
    setIconoModulo("");
    setEstadoModulo(true);
  };

  const handleCancelOrClean = () => {
    if (edit) {
      navigate(-1);
    } else {
      cleanData();
    }
  };

  useEffect(() => {
    const fetchModulo = async () => {
      try {
        if (moduloFromState) {
          setNombreModulo(moduloFromState.nombreModulo || "");
          setDescripcionModulo(moduloFromState.descripcionModulo || "");
          setRutaModulo(moduloFromState.rutaModulo || "");
          setIconoModulo(moduloFromState.iconoModulo || "");
          setEstadoModulo(
            typeof moduloFromState.estadoModulo === "boolean"
              ? moduloFromState.estadoModulo
              : true
          );
          return;
        }

        const { data } = await axios.get(`/api/seguridad/modulos/listid/${id}`);

        if (data?.ok) {
          const modulo = data.modulo || {};
          setNombreModulo(modulo.nombreModulo || "");
          setDescripcionModulo(modulo.descripcionModulo || "");
          setRutaModulo(modulo.rutaModulo || "");
          setIconoModulo(modulo.iconoModulo || "");
          setEstadoModulo(
            typeof modulo.estadoModulo === "boolean" ? modulo.estadoModulo : true
          );
        }
      } catch (error) {
        console.error("Error al obtener módulo:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "No se pudo cargar el módulo",
        });
      }
    };

    if (id) fetchModulo();
  }, [id, moduloFromState]);

  const saveModulo = async () => {
    try {
      if (!nombreModulo.trim()) {
        return Swal.fire({
          icon: "warning",
          title: "Campo requerido",
          text: "Debes ingresar el nombre del módulo",
        });
      }

      setLoading(true);

      const payload = {
        nombreModulo: nombreModulo.trim(),
        descripcionModulo: descripcionModulo.trim(),
        rutaModulo: rutaModulo.trim(),
        iconoModulo: iconoModulo.trim(),
        estadoModulo,
      };

      const { data } = await axios.post("/api/seguridad/modulos/create", payload);

      if (data?.ok) {
        Swal.fire({
          icon: "success",
          title: data?.message || "Módulo registrado correctamente",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          cleanData();
          navigate(-1);
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Atención",
          text: data?.message || "No fue posible registrar el módulo",
        });
      }
    } catch (error) {
      console.error("Error al registrar módulo:", error);
      Swal.fire({
        icon: "error",
        title: "Error al registrar",
        text: error.response?.data?.message || "Intenta nuevamente",
      });
    } finally {
      setLoading(false);
    }
  };

  const updateModulo = async () => {
    try {
      if (!nombreModulo.trim()) {
        return Swal.fire({
          icon: "warning",
          title: "Campo requerido",
          text: "Debes ingresar el nombre del módulo",
        });
      }

      setLoading(true);

      const payload = {
        nombreModulo: nombreModulo.trim(),
        descripcionModulo: descripcionModulo.trim(),
        rutaModulo: rutaModulo.trim(),
        iconoModulo: iconoModulo.trim(),
        estadoModulo,
      };

      const { data } = await axios.put(
        `/api/seguridad/modulos/edit/${id}`,
        payload
      );

      Swal.fire({
        icon: "success",
        title: data?.message || "Módulo actualizado correctamente",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        navigate(-1);
      });
    } catch (error) {
      console.error("Error al actualizar módulo:", error);
      Swal.fire({
        icon: "error",
        title: "Error al actualizar",
        text: error.response?.data?.message || "Intenta nuevamente",
      });
    } finally {
      setLoading(false);
    }
  };

  const actions = async (e) => {
    e.preventDefault();

    if (edit) {
      await updateModulo();
    } else {
      await saveModulo();
    }
  };

  return (
    <div className="bg-body-tertiary py-4">
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-3">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
            <div>
              <h4 className="mb-1 fw-semibold">
                {edit ? "Actualizar Módulo" : "Registrar Módulo"}
              </h4>
              <p className="mb-0 text-secondary small">
                Diligencia la información del módulo para su posterior asignación a roles.
              </p>
            </div>

            <div className="d-flex gap-2 flex-wrap">
              <button
                type="button"
                className="btn btn-outline-dark"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i>
                Volver
              </button>

              <button
                type="button"
                className={`btn ${edit ? "btn-outline-danger" : "btn-outline-secondary"}`}
                onClick={handleCancelOrClean}
                disabled={loading}
              >
                <i className={`fa-solid ${edit ? "fa-xmark" : "fa-eraser"} me-2`}></i>
                {edit ? "Cancelar" : "Limpiar"}
              </button>
            </div>
          </div>
        </div>

        <form onSubmit={actions}>
          <div className="row justify-content-center">
            <div className="col-12 col-xl-9">
              <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4">
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="mb-0 fw-semibold">Información del módulo</h6>
                  <span className="text-secondary small">* Obligatorio</span>
                </div>

                <hr className="my-3" />

                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label className="form-label small text-secondary text-uppercase">
                      Nombre del módulo *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={nombreModulo}
                      onChange={(e) => setNombreModulo(e.target.value)}
                      placeholder="Ej: Aprendices"
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small text-secondary text-uppercase">
                      Ruta del módulo
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={rutaModulo}
                      onChange={(e) => setRutaModulo(e.target.value)}
                      placeholder="Ej: /aprendiz"
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small text-secondary text-uppercase">
                      Ícono
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={iconoModulo}
                      onChange={(e) => setIconoModulo(e.target.value)}
                      placeholder="Ej: fa-solid fa-user-graduate"
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small text-secondary text-uppercase">
                      Estado
                    </label>
                    <select
                      className="form-select"
                      value={estadoModulo ? "true" : "false"}
                      onChange={(e) => setEstadoModulo(e.target.value === "true")}
                    >
                      <option value="true">Activo</option>
                      <option value="false">Inactivo</option>
                    </select>
                  </div>

                  <div className="col-12">
                    <label className="form-label small text-secondary text-uppercase">
                      Descripción
                    </label>
                    <textarea
                      className="form-control"
                      rows="4"
                      value={descripcionModulo}
                      onChange={(e) => setDescripcionModulo(e.target.value)}
                      placeholder="Describe el propósito del módulo dentro del sistema"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="row g-3 mt-3">
                <div className="col-12 col-md-6">
                  <button
                    type="submit"
                    className="btn btn-dark w-100 fw-semibold py-2"
                    disabled={loading}
                  >
                    {loading ? "Guardando..." : edit ? "Guardar cambios" : "Registrar módulo"}
                  </button>
                </div>

                <div className="col-12 col-md-6">
                  <button
                    type="button"
                    className={`btn w-100 fw-semibold py-2 ${
                      edit ? "btn-outline-danger" : "btn-outline-secondary"
                    }`}
                    onClick={handleCancelOrClean}
                    disabled={loading}
                  >
                    {edit ? "Cancelar" : "Limpiar"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div className="mt-4 text-center text-secondary small">
          Verifica la información antes de {edit ? "guardar cambios" : "registrar"} el módulo.
        </div>
      </div>
    </div>
  );
};

export default RegistrarModulo;